// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for generator */

.blob-2 {
	width: 80px;
	aspect-ratio: 1;
	border: 10px solid #00000000;
	background:
		radial-gradient(farthest-side, #000 98%, #0000) 0 0/20px 20px,
		radial-gradient(farthest-side, #000 98%, #0000) 100% 0/20px 20px,
		radial-gradient(farthest-side, #000 98%, #0000) 100% 100%/20px 20px,
		radial-gradient(farthest-side, #000 98%, #0000) 0 100%/20px 20px,
		linear-gradient(#000 0 0) center/40px 40px,
		#fff;
	background-repeat: no-repeat;
	filter: blur(4px) contrast(10);
	animation: b2 0.8s infinite;
}

@keyframes b2 {
	100% {
		background-position: 100% 0, 100% 100%, 0 100%, 0 0, center
	}
}

#input-area {
	display: flex;
	flex-direction: row;
	gap: 15px;
	margin: 5px;
}

#advanced-options {
	flex-grow: 0;
}

.field-error {
	color: red;
}

#file-uploader {
	flex-grow: 1;
}

#seed-options {
	display: flex;
	flex-direction: row;
	gap: 5px;
}

#Seed {
	flex-grow: 0;
	align-self: flex-start;
}

#randomize-seed {
	flex-grow: 1;
	background-color: var(--dark-purple);
	color: white;
	border-radius: 5px;
	line-height: 1;
	padding: 5px;
	border-style: none;
}

@media screen and (max-width: 1100px) {
	#input-area {
		flex-wrap: wrap;
	}

	#file-uploader {
		order: 0;
	}

	#advanced-options {
		order: 1;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Generator/Generator.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;CACC,WAAW;CACX,eAAe;CACf,4BAA4B;CAC5B;;;;;;MAMK;CACL,4BAA4B;CAC5B,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,oCAAoC;CACpC,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,QAAQ;CACT;;CAEA;EACC,QAAQ;CACT;AACD","sourcesContent":["/* Styling for generator */\r\n\r\n.blob-2 {\r\n\twidth: 80px;\r\n\taspect-ratio: 1;\r\n\tborder: 10px solid #00000000;\r\n\tbackground:\r\n\t\tradial-gradient(farthest-side, #000 98%, #0000) 0 0/20px 20px,\r\n\t\tradial-gradient(farthest-side, #000 98%, #0000) 100% 0/20px 20px,\r\n\t\tradial-gradient(farthest-side, #000 98%, #0000) 100% 100%/20px 20px,\r\n\t\tradial-gradient(farthest-side, #000 98%, #0000) 0 100%/20px 20px,\r\n\t\tlinear-gradient(#000 0 0) center/40px 40px,\r\n\t\t#fff;\r\n\tbackground-repeat: no-repeat;\r\n\tfilter: blur(4px) contrast(10);\r\n\tanimation: b2 0.8s infinite;\r\n}\r\n\r\n@keyframes b2 {\r\n\t100% {\r\n\t\tbackground-position: 100% 0, 100% 100%, 0 100%, 0 0, center\r\n\t}\r\n}\r\n\r\n#input-area {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tgap: 15px;\r\n\tmargin: 5px;\r\n}\r\n\r\n#advanced-options {\r\n\tflex-grow: 0;\r\n}\r\n\r\n.field-error {\r\n\tcolor: red;\r\n}\r\n\r\n#file-uploader {\r\n\tflex-grow: 1;\r\n}\r\n\r\n#seed-options {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tgap: 5px;\r\n}\r\n\r\n#Seed {\r\n\tflex-grow: 0;\r\n\talign-self: flex-start;\r\n}\r\n\r\n#randomize-seed {\r\n\tflex-grow: 1;\r\n\tbackground-color: var(--dark-purple);\r\n\tcolor: white;\r\n\tborder-radius: 5px;\r\n\tline-height: 1;\r\n\tpadding: 5px;\r\n\tborder-style: none;\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n\t#input-area {\r\n\t\tflex-wrap: wrap;\r\n\t}\r\n\r\n\t#file-uploader {\r\n\t\torder: 0;\r\n\t}\r\n\r\n\t#advanced-options {\r\n\t\torder: 1;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
